export default __webpack_public_path__ + "static/media/Html & css Sertifikat.cc31ed1e.png";